<template>
  <span class="badge" :class="$style.teal"><slot /></span>
</template>

<style module lang="scss">
@import "@/assets/_variables.scss";

.teal {
  --#{$prefix}badge-font-weight: normal;
  --#{$prefix}badge-font-size: 1em;
  background-color: #{$teal};
  color: white;
}
</style>